import KngOperator from './src/main';

/* istanbul ignore next */
KngOperator.install = function(Vue) {
  Vue.component(KngOperator.name, KngOperator);
};

export default KngOperator;
